import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Modal, Platform, View } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { IPushNotificationScreenViewModelType } from './IPushNotificationScreenViewModel';
import { CoreRoutes } from '../../Coordinator/Coordinator/CoreRoutes';
import { useRouteParams } from '../../Hooks/UseRouteParams';
import { component } from '../../Decorators/Component';
import { CardView } from '../../Components/Cards/CardView';
import { AnimatedImageView } from '../../Components/Image/AnimatedImageView';
import { HeaderView } from '../../Components/Navigation/HeaderView';
import { H1View } from '../../Components/Typography/H1View';
import { ParagraphView } from '../../Components/Typography/Paragraph';
import { PressableButtonView } from '../../Components/Buttons/PressableButtonView';
import { AnimatedView } from '../../Components/Common/AnimatedView';
export const PushNotificationScreenComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.pushNotification,
    dependencies: {
        viewModel: IPushNotificationScreenViewModelType
    },
    style(theme, mediaQuery, window) {
        var _a, _b;
        let backgroundColor = ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary_color)
            ? (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color
            : undefined;
        if (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.startsWith('rgb(')) {
            backgroundColor = backgroundColor
                .replace('rgb(', 'rgba(')
                .replace(')', ', 0.9)');
        }
        return {
            container: {
                flex: 1,
                backgroundColor,
                justifyContent: 'center',
                alignItems: 'center'
            },
            modal: {},
            card: Object.assign(Object.assign({ overflow: 'hidden', maxWidth: window.width - 40 }, mediaQuery.sm({
                maxWidth: 400
            })), { width: '100%' }),
            content: {
                paddingVertical: 0,
                paddingHorizontal: 0
            },
            header: {
                position: 'absolute',
                top: Platform.select({
                    default: 10,
                    web: 0
                }),
                left: 0,
                right: 0,
                zIndex: 1
            },
            body: {
                justifyContent: 'center',
                padding: 20,
            },
            footer: {
                padding: 20,
            },
            image: {
                width: '100%',
                height: 150,
            },
            title: {
                textAlign: 'center',
                marginBottom: 20
            },
            description: {
                textAlign: 'center',
                marginBottom: 20
            },
            button: {
                marginEnd: 10
            }
        };
    }
})(({ style, viewModel, navigation }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const [params] = useRouteParams(CoreRoutes.pushNotification);
    useEffect(() => {
        viewModel === null || viewModel === void 0 ? void 0 : viewModel.init(params.id);
    }, [params.id]);
    return (_jsx(Modal, { style: style === null || style === void 0 ? void 0 : style.modal, transparent: true, statusBarTranslucent: true, visible: true, animationType: 'fade', children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: _jsxs(CardView, { containerStyles: style === null || style === void 0 ? void 0 : style.card, bodyStyles: style === null || style === void 0 ? void 0 : style.content, children: [!!((_a = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _a === void 0 ? void 0 : _a.image_url) && (_jsx(AnimatedImageView, { image: (_b = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _b === void 0 ? void 0 : _b.image_url, containerStyle: style === null || style === void 0 ? void 0 : style.image, resizeMode: "cover" })), _jsx(HeaderView, { onBack: () => viewModel === null || viewModel === void 0 ? void 0 : viewModel.dismiss(params.id), isDismissButton: true, reverseHeader: true, tintColor: ((_c = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _c === void 0 ? void 0 : _c.image_url) ? '#fff' : undefined, containerStyle: style === null || style === void 0 ? void 0 : style.header }), _jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.body, !((_d = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _d === void 0 ? void 0 : _d.image_url) && { marginTop: 20 }], children: [!!((_e = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _e === void 0 ? void 0 : _e.title) && (_jsx(H1View, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: (_f = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _f === void 0 ? void 0 : _f.title })), !!((_g = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _g === void 0 ? void 0 : _g.description) && (_jsx(ParagraphView, { textStyle: style === null || style === void 0 ? void 0 : style.description, children: (_h = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _h === void 0 ? void 0 : _h.description }))] }), (((_j = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _j === void 0 ? void 0 : _j.interactions) || []).length > 0 && (_jsx(AnimatedView, { style: style === null || style === void 0 ? void 0 : style.footer, children: (_l = (_k = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _k === void 0 ? void 0 : _k.interactions) === null || _l === void 0 ? void 0 : _l.map((interaction, i) => {
                            var _a;
                            return (_jsx(PressableButtonView, Object.assign({ wrapperStyle: [style === null || style === void 0 ? void 0 : style.button, i >= (((_a = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.pushNotification) === null || _a === void 0 ? void 0 : _a.interactions) || []).length - 1 && { marginEnd: 0 }] }, interaction), interaction.action));
                        }) }))] }) }) }));
});
